/**
 * Makes all simple text and image blocks 
 * equal height inside microsite three column block and microsite two column block
 */

const colBlocks = document.querySelectorAll('.microsite-three-column-block:has(.simple-text-and-image-block.image-after), .microsite-two-column-block:has(.simple-text-and-image-block.image-after)')
let isImageSizeAttributesMissing = false
let initialLoad = true

const adjustsizes = () => {
  
  colBlocks.forEach(block => {
    const columnContainers = block.querySelectorAll('.column-container:has(.simple-text-and-image-block.image-after)')
    let maxHeight = 0
    let figureHeight = 0;

    columnContainers.forEach(container => {
      const figure = container.querySelector('.image-area figure')

      if (initialLoad && !isImageSizeAttributesMissing && figure.querySelector('img').getAttribute('height') === null) {
        isImageSizeAttributesMissing = true
      }

      container.classList.remove('height-calculated')

      if (container.clientHeight > maxHeight) maxHeight = container.clientHeight
      if (figure.clientHeight > figureHeight) figureHeight = figure.clientHeight

    })

    columnContainers.forEach(container => {
      container.style.height = `${maxHeight}px`
      container.querySelector('.image-area figure').style.height = `${figureHeight}px`
      container.classList.add('height-calculated')
    })
  })
}

adjustsizes()

window.addEventListener('resize', adjustsizes)

// just do it again if image is not in cache and was still loading with no width and height set in CMS
if (isImageSizeAttributesMissing) {
  setTimeout(() => {
    adjustsizes()
    initialLoad = false
  }, 1000)
}